export default class Totals {
    netOrderedTotal = 0;
    grossOrderedTotal = 0;
    netChargeableTotal = 0;
    grossChargeableTotal = 0;
    taxes = {};
    charges = [];
    assign(other) {
        Object.assign(this, other);
    }
}
